export const LABELS = {
  NO_PLACEHOLDER: 'No Files selected',
};
